<template>
  <div class="upload" tabindex="0" @paste="handlePaste">
    <div class="demo-upload-list" v-if="(img && !more && !file) || uploading">
<!--    <div class="demo-upload-list" >-->
      <div v-if="uploading">
        <Spin fix>
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div style="height: 20px;position: relative;top: -35px;font-size: 12px">{{ uploadProgress }}%</div>
        </Spin>
      </div>
      <div v-if="!uploading">
        <img :src="img" v-if="type === 'img'">
        <video :src="img" v-if="type === 'video'" muted preload="metadata"></video>
        <Icon v-if="type === 'video'" class="video-play-icon" type="ios-play"></Icon>
        <div class="demo-upload-list-cover">
          <Icon type="ios-eye-outline" @click.native="handleView()"></Icon>
          <Icon type="ios-trash-outline" @click.native="handleImgRemove()"></Icon>
        </div>
      </div>
    </div>
    <div class="demo-upload-list" v-for="(item,index) in imgList" :key="index">
      <img :src="item">
      <div class="demo-upload-list-cover">
        <Icon type="ios-eye-outline" @click.native="handleView(index)"></Icon>
        <Icon type="ios-trash-outline" @click.native="handleImgRemove(index)"></Icon>
      </div>
    </div>
    <Upload type="drag"
            :action="uploadUrl"
            :headers="uploadHeader"
            v-if="((!img && !more) || (imgList.length < max && more) || file) && !uploading"
            :accept="accept"
            :format="format"
            :multiple='multiple'
            :max-size="maxSize"
            :limit='max'
            :on-success="handleImgSuccess"
            :on-format-error="handleImgFormatError"
            :on-exceeded-size="handleImgMaxSize"
            :show-upload-list="showUploadList"
            :before-upload="beforeUpload"
            style="display: inline-block;">
      <slot name="upload">
        <div class="upload-action-card">
          <div class="upload-action-add">
            <Icon :type="uploadIcon" size="20"></Icon>
            <div>{{ computedUploadText }}</div>
          </div>
          <div class="upload-action-paste" @click.stop.prevent="handlePasteButton" @mousedown.stop.prevent>
            {{ computedPasteText }}
          </div>
        </div>
      </slot>
    </Upload>
    <div style="" v-if="file">{{ fileName }}</div>
    <Modal title="预览" v-model="visible">
      <img :src="img" v-if="visible && !more && type === 'img'" style="width: 100%">
      <video controls :src="img" v-if="visible && !more && type === 'video'" style="width: 100%"></video>
      <img :src="imgViewUrl" v-if="visible && more" style="width: 100%">
    </Modal>
  </div>
</template>

<script>
import OSS from 'ali-oss'
import { getToken } from '@/http/tools'
import { ossConfig } from '@/http/config'

export default {
  name: 'upload',
  data () {
    return {
      visible: false,
      imgViewUrl: '',
      uploading: false,
      uploadProgress: 0
    }
  },
  props: {
    more: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    file: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'img'
    },
    fileName: {
      type: String,
      default: ''
    },
    uploadText: {
      type: String,
      default: ''
    },
    pasteText: {
      type: String,
      default: ''
    },
    max: {
      type: Number,
      default: 6
    },
    accept: {
      type: String,
      default: 'image/png, image/jpeg, image/jpg'
    },
    format: {
      type: Array,
      default: () => {
        return ['jpg', 'jpeg', 'png']
      }
    },
    uploadUrl: {
      type: String,
      default: 'Upload/server'
    },
    uploadHeader: {
      type: [Object, Array],
      default: () => {
        return { 'AdminAuth': getToken() }
      }
    },
    maxSize: {
      type: Number,
      default: 5120
    },
    showUploadList: {
      type: Boolean,
      default: false
    },
    img: {
      type: String,
      default: ''
    },
    imgList: {
      type: Array | Object,
      default: () => {
        return []
      }
    },
    uploadFunc: {
      type: String,
      default: 'Oss'
    },
    folder: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  computed: {
    computedUploadText () {
      if (this.uploadText) return this.uploadText
      return this.type === 'video' ? '添加视频' : '添加图片'
    },
    computedPasteText () {
      if (this.pasteText) return this.pasteText
      return this.type === 'video' ? '粘贴视频' : '粘贴图片'
    },
    uploadIcon () {
      return this.type === 'video' ? 'logo-youtube' : 'md-image'
    }
  },
  created () {
    console.log(this.img)
    // if (this.uploadFunc === 'Oss') {
    //   this.getServerStsAuth()
    // }
  },
  methods: {
    async getStsAuth () {
      if (!this.$store.state.aliSts) {
        await this.getServerStsAuth()
        return this.$store.state.aliSts
      }
      let expiration = this.$store.state.aliSts.Expiration
      let uTime = new Date(expiration)
      let now = new Date()
      if (now.getTime() > uTime) {
        await this.getServerStsAuth()
      }
      return this.$store.state.aliSts
    },
    async getServerStsAuth () {
      let vm = this
      await this.$request('62110238dc4c6').then(response => {
        console.log(response.data.data)
        vm.$store.commit('setAliSts', response.data.data)
      }).catch(() => {
        vm.$Message.error('访问授权失败')
      })
    },
    handleView (index) {
      // console.log(this.imgList[index])
      if (this.more) {
        this.imgViewUrl = this.imgList[index]
      }
      this.visible = true
    },
    handleImgFormatError (file) {
      this.$Notice.warning({
        title: '文件类型不合法',
        desc: file.name + '的文件类型不正确，请上传jpg或者png图片。'
      })
    },
    handleImgRemove (index) {
      if (this.more) {
        // 多图上传
        this.imgList.splice(index, 1)
        this.$emit('update:imgList', this.imgList)
      } else {
        console.log('----9')
        // 单图上传
        this.$emit('update:img', '')
        // this.$emit('update:img', '')
        this.$emit('onRemove')
      }
    },
    handleImgSuccess (response) {
      console.log('-----1')
      if (response.code === 1) {
        this.$Message.success(response.msg)
        this.$emit('update:img', response.data.fileUrl)
      } else {
        this.$Message.error(response.msg)
      }
      this.$emit('onSuccess', response.data)
    },
    handleImgMaxSize (file) {
      this.$Notice.warning({
        title: '文件大小不合法',
        desc: file.name + '超出上传大小设置'
      })
    },
    beforeUpload (file) {
      console.log('----4')
      if (this.more && this.imgList.length >= this.max) {
        this.$Message.error(`最多上传${this.max}张图片`)
        return false
      }
      if (this.file) {
        this.$emit('update:fileName', file.name)
      }
      if (this.uploadFunc === 'Server') {
        return true
      } else if (this.uploadFunc === 'Oss') {
        this.uploadFileToOSS(file)
        return false
      } else if (this.uploadFunc === 'QiNiu') {
        this.uploadFileToQiNiu(file)
        return false
      }
    },
    uploadByFile (file) {
      if (!this.validateUploadFile(file)) return false
      return this.beforeUpload(file)
    },
    validateUploadFile (file) {
      if (!file) return false
      const fileName = file.name || ''
      const ext = fileName.indexOf('.') > -1 ? fileName.split('.').pop().toLowerCase() : ''
      if (this.format && this.format.length && ext && this.format.indexOf(ext) === -1) {
        this.handleImgFormatError(file)
        return false
      }
      if (this.maxSize && file.size > this.maxSize * 1024) {
        this.handleImgMaxSize(file)
        return false
      }
      return true
    },
    handlePaste (event) {
      const file = this.getPastedFile(event)
      if (!file) return
      event.preventDefault()
      event.stopPropagation()
      this.uploadByFile(this.renamePastedFile(file))
    },
    handlePasteButton () {
      this.$el && this.$el.focus()
      this.$Message.info(`请复制${this.type === 'video' ? '视频' : '图片'}后按 Ctrl+V 粘贴`)
    },
    getPastedFile (event) {
      const clipboardData = event.clipboardData || window.clipboardData
      if (!clipboardData) return null
      const files = clipboardData.files ? Array.from(clipboardData.files) : []
      const pastedFile = files.find(file => this.isAllowedPasteFile(file))
      if (pastedFile) return pastedFile
      const items = clipboardData.items ? Array.from(clipboardData.items) : []
      const pastedItem = items.find(item => this.isAllowedPasteFile(item))
      if (!pastedItem) return null
      return pastedItem.getAsFile()
    },
    isAllowedPasteFile (file) {
      const type = file.type || ''
      const name = file.name || ''
      const accepts = String(this.accept || '').split(',').map(item => item.trim()).filter(Boolean)
      if (!accepts.length) return type.indexOf('image/') === 0 || type.indexOf('video/') === 0
      return accepts.some(accept => {
        if (accept.endsWith('/*')) return type.indexOf(accept.replace('/*', '/')) === 0
        if (accept.indexOf('/') > -1) return type === accept
        return name.toLowerCase().endsWith(accept.toLowerCase().replace('*', ''))
      })
    },
    renamePastedFile (file) {
      if (file.name) return file
      const extMap = {
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'video/mp4': 'mp4',
        'video/quicktime': 'mov',
        'video/x-msvideo': 'avi'
      }
      const ext = extMap[file.type] || 'png'
      return new File([file], `paste-${Date.now()}.${ext}`, { type: file.type })
    },
    uploadFileToQiNiu (file) {
      console.log('---5')
      let vm = this
      getQiNiuToken().then(response => {
        let token = response.data.data.token
        let fileName = this.setFileName(file.name)
        let config = {
          useCdnDomain: qiNiuConfig.useCdnDomain,
          region: qiNiuConfig.region
        }
        let observable = QiNiuClient.upload(file, fileName, token, {}, config)
        observable.subscribe({
          next: (result) => {
            // 主要用来展示进度
            console.log('上传进度:' + result.total.percent)
          },
          error: (errResult) => {
            // 失败报错信息
            console.error(errResult)
          },
          complete: (result) => {
            // 接收成功后返回的信息
            vm.$emit('update:img', qiNiuConfig.endpoint + result.key)
          }
        })
      }).catch(() => {
        vm.$Message.error('访问授权失败')
      })
    },
    async uploadFileToOSS (file) {
      let aliSts = await this.getStsAuth(); let vm = this
      let client = OSS({
        accessKeyId: aliSts.AccessKeyId,
        accessKeySecret: aliSts.AccessKeySecret,
        stsToken: aliSts.SecurityToken,
        ...ossConfig,
        refreshSTSToken: async () => {
          // 向您搭建的STS服务获取临时访问凭证。
          let aliSts = await this.getStsAuth()
          return {
            accessKeyId: aliSts.AccessKeyId,
            accessKeySecret: aliSts.AccessKeySecret,
            stsToken: aliSts.SecurityToken
          }
        },
        // 刷新临时访问凭证的时间间隔，单位为毫秒。
        refreshSTSTokenInterval: 300000
      })
      let fileName = this.setFileName(file.name)
      this.uploading = true
      client.put(fileName, file, {
        progress: (p) => {
          this.uploadProgress = p * 100
        }
      }).then(({ res }) => {
        if (res.statusCode === 200) {
          this.uploading = false
          // let url = res.requestUrls.pop()
          let url = ossConfig.endpoint + '/' + fileName
          if (this.more) {
            if (this.imgList.length >= this.max) {
              vm.$Message.error(`最多上传${this.max}张图片`)
              return
            }
            this.imgList.push(url)
            vm.$emit('update:imgList', this.imgList.slice(0, this.max))
          } else {
            console.log('----')
            console.log(res)
            vm.$emit('update:img', url)
            // vm.$emit('update:img', "------")
          }
        } else {
          vm.$Message.error('上传失败')
        }
      }).catch(error => {
        vm.$Message.error('上传失败')
      })
    },

    // 生成文件名
    setFileName (fileName, length) {
      let sliceStart = fileName.lastIndexOf('.')
      let hz = fileName.slice(sliceStart, fileName.length)
      length = length || 32
      let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz12345678'; let maxPos = chars.length; let file = ''
      for (let i = 0; i < length; i++) {
        file += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      fileName = 'upload' + '/default/' + this.getDate() + '/' + file + hz
      return fileName
    },
    getDate () {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() > 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
      const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
      return `${year}${month}${day}`
    }
  }
}
</script>
<style lang="less">
@import "./upload.less";

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
</style>
